import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'serviceLabel', standalone: true, pure: true })
export class ServiceLabelPipe implements PipeTransform {
  transform(selectedService: string): string {
    if (!selectedService?.includes('2 Pros')) {return selectedService;}
    const services = {
      '1 hour cleaning (2 Pros)': '1 Hour (2 Pros)',
      '2.5 hour cleaning (2 Pros)': '2.5 Hours (2 Pros)',
      '4 hour cleaning (2 Pros)': '4 Hours (2 Pros)',
    };
    return services[selectedService] ?? selectedService;
  }
}
